export default {
  SHOW_MODAL(state, payload) {
    state.modal = {
      show: true,
      type: payload.type,
      message: payload.message,
      onConfirm: payload.onConfirm || null
    }
  },
  HIDE_MODAL(state) {
    state.modal.show = false
  }
}